import {UserService} from './members/user.service';
import {Inject, Injectable} from '@angular/core';
import {LOCAL_STORAGE, StorageService} from 'angular-webstorage-service';

const USER_TYPE = 'nti_admin';
const USER_STORAGE = USER_TYPE + '_user';
const LANGUAGE_STORAGE = USER_TYPE + '_lan';
const X_AUTH_TOKEN = USER_TYPE + '_x_auth_token';
const MENU_PERMISSION = USER_TYPE + '_menu_permission';
const MODULE_PERMISSION = USER_TYPE + '_module_permission';
const TAB_NAME = USER_TYPE + 'tab-name';
const DATE_FORMAT = USER_TYPE + 'vm_date_format';
const TIME_FORMAT = USER_TYPE + 'vm_time_format';

@Injectable()
export class SessionStorageService {

    constructor(@Inject(LOCAL_STORAGE) private storage: StorageService, private userService: UserService) {
    }

    public getUserSession() {
        return this.storage.get(USER_STORAGE);
    }

    public setUserSession(user: any) {
        this.storage.set(USER_STORAGE, user);
        this.userService.setUser(user);
        return this.storage.get(USER_STORAGE);
    }

    public removeUserSession() {
        this.userService.removeUser();
        return this.storage.remove(USER_STORAGE);
    }

    public getLanguageSession() {
        return this.storage.get(LANGUAGE_STORAGE) == null ? 'en' : this.storage.get(LANGUAGE_STORAGE);
    }

    public setLanguageSession(lan: string) {
        this.storage.set(LANGUAGE_STORAGE, lan);
        return this.storage.get(LANGUAGE_STORAGE);
    }

    public removeLanguageSession() {
        return this.storage.remove(LANGUAGE_STORAGE);
    }

    public getAccessTokenSession() {
        return this.storage.get(X_AUTH_TOKEN);
    }

    public setAccessTokenSession(accessToken: string) {
        this.storage.set(X_AUTH_TOKEN, accessToken);
        return this.storage.get(X_AUTH_TOKEN);
    }

    public getTabSession() {
        return this.storage.get(TAB_NAME);
    }

    public setTabSession(tab: any) {
        this.storage.set(TAB_NAME, tab);
        return this.storage.get(TAB_NAME);
    }

    public setDateFormatSession(dateTimeFormat: any) {
        this.storage.set(DATE_FORMAT, dateTimeFormat);
        return this.storage.get(DATE_FORMAT);
    }

    public getDateFormatSession() {
        return this.storage.get(DATE_FORMAT);
    }

    public setTimeFormatSession(dateTimeFormat: any) {
        this.storage.set(TIME_FORMAT, dateTimeFormat);
        return this.storage.get(TIME_FORMAT);
    }

    public getTimeFormatSession() {
        return this.storage.get(TIME_FORMAT);
    }

    public setMenuPermissionSession(menuPermission: any) {
        this.storage.set(MENU_PERMISSION, menuPermission);
        return this.storage.get(MENU_PERMISSION);
    }

    public getMenuPermissionSession() {
        return this.storage.get(MENU_PERMISSION);
    }

    public setModulePermissionSession(modulePermission: any) {
        this.storage.set(MODULE_PERMISSION, modulePermission);
        return this.storage.get(MODULE_PERMISSION);
    }

    public getModulePermissionSession() {
        return this.storage.get(MODULE_PERMISSION);
    }

}
